<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>校安輔導人員職責分配</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>校安輔導人員職責分配</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left">
                學年度：
                <select v-model="search.schYearTerm">
                  <option :value="null">請選擇</option>
                  <option v-for="item in schYearTermList" :key="item" :value="item.replace('/', '')">{{item}}</option>
                </select>　
                系所名稱：
                <select v-model="search.deptCode">
                  <option :value="null">請選擇</option>
                  <option v-for="(item, index) in deptList" :key="index" :value="item.code">{{item.value}}</option>
                </select>　
                輔導人員： <input type="text" v-model="search.keyword" />
              </div>
              <div align="center" style="padding:7px;">
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="s_dir">
                <router-link to="/tenancy-instructor/create" class="btn-upload btn s_btn_b">新增</router-link>
              </div>
              <div style=" clear:both;">
                <table class="table table-no-more table-bordered table-striped mb-none" ref="table">
                  <thead>
                    <tr>
                      <th class="text-center" width="10%">修改</th>
                      <th class="text-center" width="10%">學年度</th>
                      <th class="text-center" width="15%">輔導人員</th>
                      <th class="text-center" width="45%">輔導系所</th>
                      <th class="text-center" width="20%">最後更新時間</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="修改" class="text-center">
                        <router-link :to="'/tenancy-instructor/edit/' + item.id"><button type="button" class="mb-xs mt-xs mr-xs btn-xs btn-info"><i class="fa fa-pencil"></i></button></router-link>
                      </td>
                      <td data-title="學年度" class="text-center">{{item.schYearTerm}}</td>
                      <td data-title="輔導人員" class="text-center">{{item.name}}</td>
                      <td data-title="輔導系所" class="text-center">{{item.deptName}}</td>
                      <td data-title="最後更新時間" class="text-center">{{item.updateDate}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      search: {
        schYearTerm: null,
        deptCode: null,
        keyword: null
      },
      list: [],
      schYearTermList: [],
      deptList: []
    };
  },
  mounted() {
    let d = this.nowDate();
    let nowSchYear = d.getFullYear() - 1911;
    for (let i = nowSchYear; i >= 108; i--) {
      if (i == nowSchYear) {
        let month = d.getMonth() + 1;
        if (month < 8) continue;
        else this.schYearTermList.push(i.toString() + "/1");
      } else {
        this.schYearTermList.push(i.toString() + "/2");
        this.schYearTermList.push(i.toString() + "/1");
      }
    }
    this.$http.get("/api/shared/full-dept-list").then(a => {
      this.deptList = a.body;
    });
    this.load();
  },
  methods: {
    load() {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table)
          .DataTable()
          .destroy();
      }
      this.$http
        .get("/api/tenancyInstructor", {
          params: {
            schYearTerm: this.search.schYearTerm,
            deptCode: this.search.deptCode,
            keyword: this.search.keyword
          }
        })
        .then(a => {
          this.list = a.body;
          this.$nextTick(b => {
            $(this.$refs.table).DataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁"
              },
              columnDefs: [
                {
                  targets: 0,
                  orderable: false,
                }
              ],
              order: [1, "desc"],
              columns: [
                { width: "10%" },
                { width: "10%" },
                { width: "15%" },
                { width: "45%" },
                { width: "20%" }
              ]
            });
          });
        });
    },
    searchSubmit() {
      this.load();
    },
    searchClear() {
      this.search.schYearTerm = null;
      this.search.deptCode = null;
      this.search.keyword = null;
    }
  }
};
</script>

<style>
</style>